export default ({
    status: [
        { label: 'All', value: 'All' },
        { label: 'Pending', value: 'Pending' },
        { label: 'In Progress', value: 'In Progress' },
        { label: 'Complete', value: 'Complete' },
        { label: 'Picked Up', value: 'Picked Up' },
        { label: 'See Counter', value: 'See Counter' },
        { label: 'Open', value: 'Open' },
        { label: 'Cancelled', value: 'Cancelled' },
        { label: 'Error', value: 'Error' },
    ],
    orderTypes: ['All', 'Curbside', 'Online', 'Walk up', 'Call in', 'Kiosk', 'Scan to pay', 'Table', 'Tab'],
    tooltipColumns1: [
        {
            type: "managerLogin",
            name: "Pre Auth",
        },
        {
            type: "futureOrders",
            name: "Future Orders",
        },
        // Removed Jira Ticket #ODF-4511
        // {
        //     type: "checkIn",
        //     name: "Text to Check In",
        // },
        // {
        //     type: "textToPay",
        //     name: "Text To Pay",
        // },
        {
            type: "bulkTextToPay",
            name: "Bulk Text To Pay",
        },
        {
            type: "payNow",
            name: "Scan To Pay",
        },
        {
            type: "outOfStock",
            name: "Out Of Stock",
        },
        {
            type: "productionRate",
            name: "Store Production",
        },
        {
            type: "sort",
            name: "Settings",
        },
        {
            type: "tableMerge",
            name: "Table Merge",
        },
        {
            type: "employeeAssignment",
            name: "Assign Employee",
        },
    ],
    tooltipColumns2: [
        {
            type: "tileView",
            name: "Tile View"
        },
        {
            type: "layoutView",
            name: "Layout View",
        },
        {
            type: 'layoutDesign',
            name: 'Layout Design',
        },
        {
            type: "marketplaceStatus",
            name: "Marketplace Status"
        },
        {
            type: "sensors",
            name: "Sensors",
        },
        {
            type: "channels",
            name: "Channels",
        },
        {
            type: "settings",
            name: "Filters",
        },
        {
            type: "diagnostics",
            name: "Diagnostics",
        },
        // {
        //     type: "networkLogs",
        //     name: "Network Logs",
        // },
        {
            type: "launchExternalApp",
            name: "",
        },
        {
            type: "syncChecks",
            name: "Sync Checks",
        },
        {
            type: "about",
            name: "About",
        },
    ],
});